import { fetchMultistageOlympiadWidgetList } from 'api/configurators';
import useUserData from 'hooks/useUserData';
import { Widget } from 'models/widgetMultiStageOlympiad';
import React, { useContext, useEffect, useMemo, useState } from 'react';

export interface WidgetList extends Widget {
  showForMunicipality: boolean;
  showForRegion: boolean;
}

export interface ConfiguratorsContextProps {
  loaded: boolean;
  multiStageWidgets: WidgetList[];
}

const defaultContext: ConfiguratorsContextProps = {
  loaded: false,
  multiStageWidgets: [],
};

const Context = React.createContext<ConfiguratorsContextProps>(defaultContext);

const ConfiguratorsContext = (props: React.PropsWithChildren<{}>) => {
  const userData = useUserData();
  const [loaded, setLoaded] = useState(false);
  const [multiStageWidgets, setMultiStageWidgets] = useState<Widget[]>([]);

  const fetchMultiStageWidgets = async () => {
    try {
      const data = await fetchMultistageOlympiadWidgetList();
      setMultiStageWidgets(data || []);
      setLoaded(true);
    } catch (error) {
      console.error(error);
      setLoaded(true);
    }
  };

  const mappedMultiStageWidgets: WidgetList[] = useMemo(() => {
    const userId = userData?.id.toString();
    if (!userId) {
      return [];
    }
    return multiStageWidgets.map((widget) => ({
      ...widget,
      showForMunicipality: widget.munitipalityIds.split(',').some((id) => {
        return id.match(/\d+/)?.at(0) === userId;
      }),
      showForRegion: widget.regionIds.split(',').some((id) => {
        return id.match(/\d+/)?.at(0) === userId;
      }),
    }));
  }, [multiStageWidgets, userData]);

  useEffect(() => {
    fetchMultiStageWidgets();
  }, []);

  return (
    <Context.Provider
      value={{
        loaded,
        multiStageWidgets: mappedMultiStageWidgets,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export const useConfiguratorsContext = () => useContext(Context);

export default ConfiguratorsContext;

